import { useSelector } from 'react-redux';

export const MakeFields = () => {
  const { rut, orderId, cud, sku } = useSelector((state) => state.issuesSlice);

  return [
    {
      name: 'sku',
      label: 'SKU',
      disabled: true,
      required: true,
      value: sku,
      hidden: true,
    },
    {
      name: 'cud',
      label: 'Cud',
      disabled: true,
      required: false,
      value: cud,
      hidden: true,
    },
    {
      name: 'orderId',
      inputAdornment: '',
      label: 'N° de orden de compra',
      disabled: true,
      required: true,
      helper: 'Ingresar 8 , 9 u 11 dígitos',
      value: orderId,
      hidden: true,
    },
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      disabled: true,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
      value: rut,
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      disabled: false,
      required: true,
    },
    {
      name: 'assembleAddress',
      inputAdornment: '',
      label: 'Dirección de armado',
      disabled: false,
      required: true,
      helper: 'Dirección, número, depto /casa/oficina',
    },
    {
      name: 'comment',
      inputAdornment: '',
      label: 'Escribir comentario',
      disabled: false,
      required: false,
      rows: 4,
      multiline: true,
    },
  ];
};
